/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {AnyAction, CollectionFactory, Reducer} from '@modifi/redux'
import {BeneficialOwnerView, getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {createSelector} from 'reselect'

const apiClient = getAuthenticatedThemisClient()

export type BeneficialOwnerViewWithExternalId = BeneficialOwnerView & {
  externalId: NonNullable<BeneficialOwnerView['externalId']>
}

const {reducer, selectors, actions} = CollectionFactory<
  Record<string, any>,
  BeneficialOwnerViewWithExternalId,
  any,
  Record<string, never>
>({
  entityPrimaryKeySelector: entity => entity.externalId!,
  rootSelector: state => state?.data?.beneficialOwners,
  actionNamePrefix: `data/beneficial-owners`,
  fetchRequest: () =>
    apiClient.BeneficialOwners.fetch().then(
      res => (res.data()?.beneficialOwners as BeneficialOwnerViewWithExternalId[]) || []
    ),
})

export default reducer as Reducer

export const selectBeneficialOwners = (
  state: Record<string, any>
): BeneficialOwnerViewWithExternalId[] =>
  selectors.selectByKeyWindow(state, 'all') as BeneficialOwnerViewWithExternalId[]

export const selectBeneficialOwnersWhereLoaded = (state: Record<string, any>): boolean =>
  selectors.selectFetchCountByKeyWindow(state, 'all') > 0

export const selectBeneficialOwnersAreLoading = (state: Record<string, any>): boolean =>
  selectors.selectIsKeyWindowLoading(state, 'all')

export const selectBeneficialOwnerByExternalId = (
  state: Record<string, any>,
  externalPersonId: string
): BeneficialOwnerView | null =>
  selectors.selectById(state, externalPersonId) as BeneficialOwnerView | null

export const selectBeneficialOwnerNameByExternalId = createSelector(
  selectBeneficialOwnerByExternalId,
  ubo => (ubo ? `${ubo?.firstName || ''} ${ubo?.lastName || ''}` : '')
)

export const aFetchBeneficialOwners = (): any => actions!.fetch('all')

export const aUpdateLocalBeneficialOwner = (
  beneficialOwner: BeneficialOwnerViewWithExternalId,
  merge = true
): AnyAction => actions!.update(beneficialOwner, merge) as unknown as AnyAction

export const aAppendBeneficialOwnerToCompany = (
  entity: BeneficialOwnerViewWithExternalId
): AnyAction => actions!.appendEntity?.('all', {ident: entity.externalId, entity}) as AnyAction

export const aDeleteLocalBeneficialOwner = (externalPersonId: string): AnyAction =>
  actions!.deleteEntity?.('all', externalPersonId) as AnyAction
